import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Accordion, Pagination } from "react-bootstrap";
import { deleteExtraction, retrieveExtractions, selectGame } from "../../../functions/gameExtraction";
import GameExtraction from "./GameExtraction";
import PageLayout from "../../PageLayout";

function GameExtractionDisplayer({ token, onError, onSearchProductClicked }) {
    const { t } = useTranslation('messages');
    const [extractions, setExtractions] = useState([]);
    const [page, setPage] = useState(0);

    useEffect(() => {
        retrieveExtractions(token, (data) => setExtractions(data), onError, page);
    }, [token, onError, page]);

    return (
        <PageLayout
            hero={<h1 className="display-5 fw-bold mb-0">{t('private_area.game_extractions_tab.title')}</h1>}
            heroCenter
        >
            <Accordion alwaysOpen>
                {extractions.map((extraction, index) => (
                    <GameExtraction
                        key={index}
                        token={token}
                        onError={onError}
                        accordionIndex={index}
                        extraction={extraction}
                        onSearchProductClicked={onSearchProductClicked}
                        onDeleteExtractionClicked={(e) =>
                            onDeleteExtractionClicked(e, token, onError, extractions, setExtractions, extraction.game_extraction_id)
                        }
                        onSelectGameClicked={(e, game_extraction_id, game_extraction_result_id, selected) =>
                            onSelectGameClicked(e, token, onError, extractions, setExtractions, game_extraction_id, game_extraction_result_id, selected)
                        }
                    />
                ))}
            </Accordion>
            <div className="d-flex justify-content-center mt-4">
                <Pagination>
                    <Pagination.Prev onClick={() => changePage(setPage, page - 1)} />
                    <Pagination.Item active>{page}</Pagination.Item>
                    <Pagination.Next onClick={() => changePage(setPage, page + 1)} />
                </Pagination>
            </div>
        </PageLayout>
    );
}

function onDeleteExtractionClicked(e, token, onError, extractions, setExtractions, gameExtractionId) {
    e.preventDefault();
    deleteExtraction(token, () => {
        setExtractions(extractions.filter((ex) => ex.game_extraction_id !== gameExtractionId));
    }, onError, gameExtractionId);
}

function onSelectGameClicked(e, token, onError, extractions, setExtractions, game_extraction_id, game_extraction_result_id, selected) {
    e.preventDefault();
    selectGame(token, () => {
        let extraction = extractions.find(ex => ex.game_extraction_id === game_extraction_id);
        let game = extraction.games.find(g => g.game_extraction_result_id === game_extraction_result_id);
        game.selected = selected;
        setExtractions([...extractions]);
    }, onError, game_extraction_id, game_extraction_result_id, selected);
}

function changePage(setPage, newPage) {
    if (newPage >= 0) setPage(newPage);
}

export default GameExtractionDisplayer;
